import React, { useEffect, useState } from 'react'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import DestinationInner from '../Components/Destination/DestinationInner'
import ScrollToTop from '../Components/ScrollToTop'
import { useParams } from 'react-router-dom'
import { apiUrl } from '../Constants/contant'

function Destination() {

    const id = useParams();

       const [destination, setDestination] = useState([]);
       const [category, setCategory] = useState([]);
      
    
    useEffect(() => {
      fetch(apiUrl + `destination/${id?.id}`)
        .then(response => response.json()) // ✅ JSON convert
        .then(data => {
          setDestination(data.destination);
          setCategory(data.category);
        })
        .catch(error => {
          console.error("There was an error fetching sliders!", error);
        });
    }, [id]);
    
    return (
        <>
            <Breadcrumb
                title="Destination"
            />
            <DestinationInner destination={destination}/>
            <ScrollToTop />
        </>
    )
}

export default Destination
